import { API_BASE_URL } from 'utils/constants';

// Tells the API whether the member's conversation is on screen in this tab, so it skips the push only then
// (nutivate-api#101). A report lasts 90 seconds, so it's repeated every minute while the site is open.
const HEARTBEAT_MS = 60 * 1000;

let openConversationId = null;
let timer = null;

// One id per page load, so every tab (also a duplicated one) reports on its own. A reload's previous id was
// cleared on pagehide.
const deviceId = `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

const authHeaders = () => {
  try {
    return JSON.parse(localStorage.getItem('authHeaders'));
  } catch (error) {
    return null;
  }
};

const report = ({ closing = false, headers = authHeaders() } = {}) => {
  clearTimeout(timer);
  if (!closing) timer = setTimeout(report, HEARTBEAT_MS);

  if (!headers || !headers.token) return;

  const conversationId = !closing && document.visibilityState === 'visible' ? openConversationId : null;
  // fetch, so a failed report never goes through the site's sign-out handling.
  fetch(`${API_BASE_URL}/users/chat_viewing`, {
    method: 'PUT',
    // The API names its auth headers token, client, expiry and uid, as stored at sign-in.
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: deviceId, conversation_id: conversationId || '' }),
    // Lets the last report out while the tab closes.
    keepalive: closing,
  }).catch(() => {});
};

// Changes can arrive in pairs (one closes, the next opens), so they're sent together.
const scheduleReport = () => {
  clearTimeout(timer);
  timer = setTimeout(report, 300);
};

export const setOpenConversation = (conversationId) => {
  openConversationId = conversationId;
  scheduleReport();
};

// Only if it's still the open one: React 16 runs each conversation's effects in list order.
export const closeConversation = (conversationId) => {
  if (openConversationId !== conversationId) return;
  openConversationId = null;
  scheduleReport();
};

// Logout removes the stored headers, so the last report goes out with the ones the logout used.
export const endChatViewing = (headers) => {
  openConversationId = null;
  if (headers) report({ closing: true, headers });
};

export const startChatViewing = () => {
  document.addEventListener('visibilitychange', scheduleReport);
  // Closing or leaving the tab tries to clear its report at once (keepalive; a browser may still drop it while the
  // page unloads, and then the report simply expires after 90 seconds). A page restored from the back/forward cache
  // reports again and restarts the heartbeat.
  window.addEventListener('pagehide', () => report({ closing: true }));
  window.addEventListener('pageshow', (event) => event.persisted && scheduleReport());
  scheduleReport();
};
